/** X かんたん接続（OAuth コールバック ?connected=）の結果表示（純粋関数） */

/** X かんたん接続（OAuth）の失敗理由コード → 表示文言 */
const X_CONNECT_REASON: Record<string, string> = {
  not_configured: 'X かんたん接続はまだ利用できません（サーバーの設定待ちです）。「X を接続（自分のキー）」をお使いください',
  state_invalid: '接続の有効期限が切れたか、別の画面から開かれました。もう一度「X かんたん接続」からやり直してください',
  denied: 'X 側で連携が許可されませんでした。もう一度お試しください',
  token_failed: 'X から認証情報を受け取れませんでした。時間をおいてもう一度お試しください',
  unknown: '原因不明のエラーで接続できませんでした。時間をおいてもう一度お試しください',
}

export function xConnectResult(connected: string | null, reason: string | null): { kind: 'success' | 'error'; message: string } | null {
  if (connected === 'x') return { kind: 'success', message: 'X を接続しました' }
  if (connected === 'x_failed') {
    return { kind: 'error', message: `X の接続に失敗しました: ${X_CONNECT_REASON[reason ?? ''] ?? X_CONNECT_REASON.unknown}` }
  }
  return null
}
